import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { LoanNotes } from "@app/models/loan-notes";
import { LoansNotesService } from "@app/services/loans-notes.service";

@Component({
    selector: "app-select-loan-note-popup",
    templateUrl: "./select-loan-note-popup.component.html",
    styleUrls: ["./select-loan-note-popup.component.css"],
    standalone: false
})
export class SelectLoanNotePopupComponent implements OnInit {
  @Input() loanNotes: Array<LoanNotes>;
  @Input() displaySearchDialog: boolean;
  @Input() selectedLoanNotes: Array<LoanNotes>;
  @Output() onSubmit = new EventEmitter<Array<LoanNotes>>();
  @Output() onCancel = new EventEmitter();

  constructor(private loanNotesService: LoansNotesService) {}

  ngOnInit() {
    if (!this.selectedLoanNotes) {
      this.selectedLoanNotes = [];
    }
  }

  hideSearch() {
    this.onCancel.emit();
  }

  onSelect(loanNote) {
    if (loanNote) {
      const parentIds = this.loanNotesService.findLoanNoteParents(loanNote, this.loanNotes);
      this.selectedLoanNotes = [
        ...this.selectedLoanNotes.filter((p) => !this.checkIfParentIdInTheList(parentIds, p)),
      ];
      this.selectedLoanNotes.push(loanNote);
    }
  }

  onSave() {
    this.onSubmit.emit(this.selectedLoanNotes);
  }

  deleteSelectedLoanNote(loanNote) {
    if (loanNote) {
      var children = this.findAllChidren(loanNote);
      this.selectedLoanNotes = this.selectedLoanNotes.filter((item) => !children.find((p) => p.id == item.id));

      if (loanNote.parentLoanNoteId) {
        var parent = this.loanNotesService.findLoanNoteById(loanNote.parentLoanNoteId, this.loanNotes);
        this.selectedLoanNotes.push(parent);
      }
    }
  }

  checkIfParentIdInTheList(checkArray: LoanNotes[], loanNote: LoanNotes) {
    const set1 = new Set(checkArray);
    const orignalLoanNote = this.loanNotesService.findLoanNoteById(loanNote.id, this.loanNotes);
    const parents = this.loanNotesService.findLoanNoteParents(orignalLoanNote, this.loanNotes);
    for (const element of parents) {
      if (set1.has(element)) {
        return true;
      }
    }
    return false;
  }

  findAllChidren(loanNote: LoanNotes) {
    var items = [];
    if (loanNote) {
      items.push(loanNote);
      if (loanNote.subLoanNotes && loanNote.subLoanNotes.length > 0) {
        loanNote.subLoanNotes.forEach((p) => {
          items = items.concat(this.findAllChidren(p));
        });
      }
    }
    return items;
  }
}
